// extracted by mini-css-extract-plugin
module.exports = {"link":"customLink_link__4AvgX"};